import { useGetUserTagFollowsQuery } from './graphql/userTagFollows.types'

export const useUserTagFollows = () => {
  const { data, loading, error } = useGetUserTagFollowsQuery()
  const followedTags = data?.getUserTagFollows ?? []
  const followedTagsById = followedTags.reduce((acc: Record<string, string>, tag) => ({
    ...acc,
    ...(tag?.tag_id && {[tag.tag_id]: tag.tag_id })
  }), {})

  const isTagFollowed = (tagId: string) => !!followedTagsById[tagId]

  return {
    isTagFollowed,
    followedTags,
    error,
    loading
  }
}
